import { render, staticRenderFns } from "./CbsCatalog.vue?vue&type=template&id=4ce0d3f2&scoped=true"
import script from "./CbsCatalog.vue?vue&type=script&lang=js"
export * from "./CbsCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce0d3f2",
  null
  
)

export default component.exports